<div [ngClass]="'rounded-card-container ' + colorClass">
   <div class="rounded-card-inner">
      <div
         class="rounded-card-header"
         *ngIf="cardTitle">
         <h3 [class]="'rounded-card-title ' + titleSize">
            {{ cardTitle }}
         </h3>
      </div>

      <div class="rounded-card-body">
         <ng-content></ng-content>
      </div>
   </div>
</div>
